<template><div><h1 id="attribute" tabindex="-1"><a class="header-anchor" href="#attribute"><span>Attribute</span></a></h1>
<p>Attribute — Attribute zur zielgruppenspezifischen Textproduktion</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Attribute werden für die zielgruppenspezifischen Texte verwendet. Die möglichen Attribute sind vorgegeben.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Document Output → Attribute</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Attribut</dt>
<dd>Bezeichnung des Attributes (muss mit der Festlegung im XSL-Stylesheet übereinstimmen)</dd>
<dt>Wert</dt>
<dd>Wert, zu dem der Text angezeigt werden soll</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/dokumentproduktion.html" title="2. Document Output">Document-Output</RouteLink></p>
</div></template>


